import { type FC, type ReactElement } from "react";
import * as styles from "./styles.css";

type Props = {
  heading: string;
  handleOnClick: () => void;
  children: ReactElement;
};

export const DeletableCassette: FC<Props> = ({ heading, handleOnClick, children }) => (
  <div className={styles.cassette}>
    <div className={styles.heading}>
      {heading}
      <button className={styles.deleteButton} type="button" onClick={handleOnClick} />
    </div>
    <div className={styles.cassetteBody}>{children}</div>
  </div>
);
